import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AutoResetDonationFlow } from './-components/flows/auto-reset-donation-flow';
import { UpdatePortalOnConfirmedDonationFlow } from './-components/flows/update-portal-on-confirmed-donation-flow';
import { FormTranslationsProvider } from '../-components/form-translations-provider';
import { lazy, Suspense } from 'react';

const StandaloneDonationsFlow = lazy(() =>
	import('./-components/flows/standalone-donations-flow').then((m) => ({ default: m.StandaloneDonationsFlow })),
);

export const Route = createFileRoute('/$portalId')({
	component: RouteComponent,
});

// `<NotFound />`, not `throw notFound()`: a streamed render-phase throw client-renders the whole tree.
// TODO: restore the throw once a 404 survives a streamed render.
function RouteComponent() {
	const { iframe } = Route.useSearch();
	// Request-scoped: concurrent SSR renders clobber the global's locale (React #418). See createLocaleI18n.
	const { i18n } = Route.useRouteContext();

	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<AutoResetDonationFlow />
				{iframe && (
					<Suspense>
						<StandaloneDonationsFlow />
					</Suspense>
				)}
				<UpdatePortalOnConfirmedDonationFlow />
				<Outlet />
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
